import React, { useState } from 'react'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'
import TypeOfWorkList from './TypeOfWorkList'

function TypeOfWork() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<TypeOfWorkList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default TypeOfWork